import React, { useEffect, useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import { uploadsAPI } from '../services/api';

const Lightbox = ({ photos, index, onClose, onMove, testId }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') onMove(1);
      if (e.key === 'ArrowLeft') onMove(-1);
    };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = ''; };
  }, [onClose, onMove]);

  return (
    <div className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4" onClick={onClose} data-testid={`${testId}-lightbox`}>
      <button type="button" onClick={onClose} className="absolute top-4 right-4 text-white/80 hover:text-white p-2" data-testid={`${testId}-lightbox-close`} aria-label="Fermer"><X size={28} /></button>
      {photos.length > 1 && (
        <>
          <button type="button" onClick={(e) => { e.stopPropagation(); onMove(-1); }} className="absolute left-3 sm:left-6 text-white/80 hover:text-white p-2 bg-white/10 rounded-full" data-testid={`${testId}-lightbox-prev`} aria-label="Précédente"><ChevronLeft size={28} /></button>
          <button type="button" onClick={(e) => { e.stopPropagation(); onMove(1); }} className="absolute right-3 sm:right-6 text-white/80 hover:text-white p-2 bg-white/10 rounded-full" data-testid={`${testId}-lightbox-next`} aria-label="Suivante"><ChevronRight size={28} /></button>
        </>
      )}
      <img src={uploadsAPI.resolveUrl(photos[index])} alt={`Photo client ${index + 1}`} onClick={(e) => e.stopPropagation()} className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl" data-testid={`${testId}-lightbox-image`} />
      <span className="absolute bottom-4 text-white/80 text-sm" data-testid={`${testId}-lightbox-counter`}>{index + 1} / {photos.length}</span>
    </div>
  );
};

const ReviewPhotos = ({ photos, testId = 'review-photos', size = 'w-20 h-20' }) => {
  const [open, setOpen] = useState(null);
  if (!photos?.length) return null;
  const move = (d) => setOpen(i => (i + d + photos.length) % photos.length);
  return (
    <>
      <div className="flex flex-wrap gap-2 mt-2" data-testid={testId}>
        {photos.map((url, i) => (
          <button key={url} type="button" onClick={() => setOpen(i)} data-testid={`${testId}-${i}`} title="Agrandir"
            className={`${size} rounded-md border border-gray-200 bg-white overflow-hidden hover:ring-2 hover:ring-orange-400 transition-shadow`}>
            <img src={uploadsAPI.resolveUrl(url)} alt={`Photo client ${i + 1}`} className="w-full h-full object-cover" loading="lazy" />
          </button>
        ))}
      </div>
      {open !== null && <Lightbox photos={photos} index={open} onClose={() => setOpen(null)} onMove={move} testId={testId} />}
    </>
  );
};

export default ReviewPhotos;
